import { AxiosResponse, GenericAbortSignal } from 'axios';
import IUseHook, { IUseHookErrorData } from 'hooks/@types';

enum IEUseExternalTokenMatchParams {
  TOKEN = 'token',
}

interface IUseExternalTokenProps {
  token: string;
  signal?: GenericAbortSignal;
}

interface IUseExternalToken extends Omit<IUseHook, 'error'> {
  loanding: boolean;
  data: IUseExternalTokenData | null;
  error: IUseHookErrorData | null;
  verify: (data: IUseExternalTokenProps) => Promise<AxiosResponse>;
}

interface IUseExternalTokenData {
  code: number;
  status: boolean;
  message: string;
  user_id: number | null;
  token: string | null;
}

export default IUseExternalToken;
export type { IUseExternalTokenProps, IUseExternalTokenData };
export { IEUseExternalTokenMatchParams };
